export interface BulkImportLocalOrder {
    sale_order: {
        id: string;
        order_name: string;
        customer_name: string;
    };
    quantity: number;
}

export const getTotalQuantity = (orders: Pick<BulkImportLocalOrder, "quantity">[]) =>
    orders.reduce((sum, order) => sum + Number(order.quantity || 0), 0);

export const allocateOrderQuantities = <T extends BulkImportLocalOrder>(
    orders: T[],
    requestedTotal: number,
): T[] => {
    let remaining = requestedTotal;

    const allocatedOrders = orders.map((order) => {
        const originalQuantity = Number(order.quantity || 0);
        const quantity = Math.max(0, Math.min(originalQuantity, remaining));
        remaining -= quantity;
        return {
            ...order,
            quantity,
        };
    });

    if (remaining > 0 && allocatedOrders.length > 0) {
        const lastOrderIndex = allocatedOrders.length - 1;
        allocatedOrders[lastOrderIndex] = {
            ...allocatedOrders[lastOrderIndex],
            quantity: allocatedOrders[lastOrderIndex].quantity + remaining,
        };
    }

    return allocatedOrders;
};

export const filterPositiveOrderQuantities = <T extends BulkImportLocalOrder>(orders: T[]) =>
    orders.filter((order) => Number(order.quantity || 0) > 0);

export const validateRequestedTotal = (
    originalOrders: BulkImportLocalOrder[],
    requestedTotal: number,
): string | null => {
    if (!Number.isFinite(requestedTotal) || !Number.isInteger(requestedTotal)) {
        return "Tổng số lượng đề nghị nhập phải là số nguyên.";
    }
    if (requestedTotal < 0) {
        return "Tổng số lượng đề nghị nhập không được nhỏ hơn 0.";
    }

    return null;
};

export const validateOrderQuantity = (
    _originalQuantity: number,
    requestedQuantity: number,
): string | null => {
    if (!Number.isFinite(requestedQuantity) || !Number.isInteger(requestedQuantity)) {
        return "Số lượng theo đơn hàng phải là số nguyên.";
    }
    if (requestedQuantity < 0) {
        return "Số lượng theo đơn hàng không được nhỏ hơn 0.";
    }

    return null;
};
